import {
    authConstants
  } from "./../constants/auth-constants";
  

  let user = JSON.parse(localStorage.getItem('user'));
    const initialState = user ? { loggedIn: true, user } : {};
  function authReducer(state = initialState, action) {
  //  const { type, payload } = action;
  
    switch (action.type) {
      case authConstants.LOGIN_SUCCESS:
        return {
          ...state, // Preserve existing state
            loggingIn: true,
            user: action.user
          };
          case authConstants.GET_USER:
            
            return {
              ...state, // Preserve existing state
                loggingIn: true,
                user: action.payload
              };

              case authConstants.VERIFY_EMAIL:
            
            return {
              ...state, // Preserve existing state
                loggingIn: false,
                user: action.payload
              };
              case authConstants.VERIFY_EMAIL_ADDRESS:
            
            return {
              ...state, // Preserve existing state
                loggingIn: false,
                verifyEmail: action.payload
              };
         
      default:
        return state;
    }
  };
  
  export default authReducer;